<template>
  <v-form v-model="valid">
    <v-tabs v-model="tab" background-color="transparent" grow>
      <v-tab v-for="item in tabs" :key="item">
        {{ item }}
      </v-tab>
    </v-tabs>

    <div class="mx-auto mt-4" style="max-width: 700px;">
      <v-card flat>
        <v-card-text v-if="currentActiveTab === $t('deposit')">
          <v-select
            v-model="depositType"
            :items="depositTypeItems"
            prepend-icon="mdi-account-credit-card-outline"
            item-text="text"
            item-value="value"
            return-object
            dense
            filled
            hide-details
            solo-inverted
          ></v-select>
          <v-text-field
            v-model="depositValue"
            class="pt-4"
            :placeholder="$t('value')"
            solo-inverted
            dense
            prepend-icon="mdi-cash"
            :prefix="$t('labelCurrency')"
            type="number"
            hide-details="auto"
            :rules="depositRules"
            :counter="5"
          ></v-text-field>
        </v-card-text>
        <v-card-text v-else-if="currentActiveTab === $t('withdraw')">
          <v-select
            v-model="withdrawType"
            :items="withdrawTypeItems"
            label="Tipo de Saque"
            prepend-icon="mdi-account-credit-card-outline"
            item-text="text"
            item-value="value"
            return-object
            dense
            filled
            hide-details
            solo-inverted
          ></v-select>
          <v-text-field
            v-model="withdrawId"
            :placeholder="withdrawIdPlaceholder"
            :rules="withdrawRules"
            class="pt-4"
            solo-inverted
            dense
            hide-details="auto"
            prepend-icon="mdi-cash"
            type="number"
            :counter="8"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            type="submit"
            class="ma-2"
            @click.prevent="openDialog"
            :loading="loadingWithdrawData"
            :disabled="
              !valid ||
                loadingWithdrawData ||
                (currentActiveTab == $t('withdraw') && !withdrawId) ||
                (currentActiveTab == $t('deposit') && !depositValue)
            "
          >
            {{ $t("continue") }}
          </v-btn>
        </v-card-actions>
        <DepositForPlayerDialog
          :dialog="depositDialog"
          :userName="userName"
          :pix="depositType.value === 'pix'"
          :depositType="depositType.value"
          :paybrokersV4="paybrokersV4"
          :value="depositValue"
          @closeDialog="depositDialog = false"
          @resetFields="resetFields"
        />
        <WithdrawForPlayerDialog
          :dialog="withdrawDialog"
          :withdrawData="withdrawData"
          @closeDialog="withdrawDialog = false"
          @resetWithdrawId="withdrawId = null"
        />
      </v-card>
    </div>
  </v-form>
</template>
<script>
import { validate } from "@/util/validate";
import DepositForPlayerDialog from "./dialog/depositForPlayerDialog.vue";
import WithdrawForPlayerDialog from "./dialog/withdrawForPlayerDialog.vue";

export default {
  props: ["userLogin", "userName", "userId"],
  components: { DepositForPlayerDialog, WithdrawForPlayerDialog },
  data: (self) => ({
    tab: 0,
    tabs: [self.$t("deposit"), self.$t("withdraw")],
    depositDialog: false,
    depositType: {
      text: "PIX via Paybrokers",
      value: "pix",
    },
    depositTypeItems: [
      { text: "PIX via Paybrokers", value: "pix" },
      {
        text: "PIX via Paag",
        value: "paag",
      },
      { text: "Manual", value: "manual" },
    ],
    depositValue: null,
    withdrawType: {
      text: "Manual",
      value: "manual",
    },
    withdrawDialog: false,
    withdrawTypeItems: [{ text: "Manual", value: "manual" }],
    withdrawId: null,
    withdrawData: {},
    loadingWithdrawData: false,
    depositRules: [
      validate.max5Characters,
      validate.negativeNo,
      validate.minDepositRule,
    ],
    withdrawRules: [validate.max8Characters, validate.negativeNo],
    lastWithdrawId: 0,
    valid: false,
  }),

  created() {
    let hasPaybrokersDeposit = false;
    let paybrokersV4 = false;
    let hasPaybrokersWithdraw = false;
    let hasPaagDeposit = false;

    const pixMethodId = 1;
    const paymentProviders = {
      Paybrokers: "1",
      Pay4Fun: "2",
      Paag: "7",
    };

    this.paymentMethods.forEach((method) => {
      if (paymentProviders.Paag == method.id_gateway) {
        if (method.fluxo == "1" && method.method_status == "1") {
          hasPaagDeposit = true;
        }
      } else if (paymentProviders.Paybrokers == method.id_gateway) {
        if (pixMethodId == method.id_metodo) {
          if (method.fluxo == "1" && method.method_status == "1") {
            hasPaybrokersDeposit = true;
          }
          if (method.fluxo == "1" && method.method_Status == "1") {
            hasPaybrokersWithdraw = true;
          }
        }
      } else if (method.nome_gateway === "PaybrokersV4") {
        if (method.fluxo == "1" && method.method_status == "1") {
          hasPaybrokersDeposit = true;
          paybrokersV4 = true;
        }

        if (method.fluxo == "2" && method.method_status == "1") {
          hasPaybrokersWithdraw = true;
        }
      }
    });

    if (
      !hasPaybrokersDeposit &&
      !this.$permission("40") &&
      !this.$permission("38")
    ) {
      this.tabs = this.tabs.filter((tab) => tab != this.$t("deposit"));
    } else if (!hasPaybrokersDeposit || !this.$permission("40")) {
      this.depositTypeItems = this.depositTypeItems.filter(
        (item) => item.value != "pix"
      );
      this.depositType = {
        text: "Manual",
        value: "manual",
      };
    } else if (!this.$permission("38")) {
      this.depositTypeItems = this.depositTypeItems.filter(
        (item) => item.value != "manual"
      );
      this.depositType = {
        text: "PIX",
        value: "pix",
      };
    }

    if (!hasPaybrokersWithdraw && !this.$permission("39")) {
      this.tabs = this.tabs.filter((tab) => tab != this.$t("withdraw"));
    }

    if (hasPaybrokersDeposit) {
      this.paybrokersV4 = paybrokersV4;
    }

    if (!hasPaagDeposit) {
      this.depositTypeItems = this.depositTypeItems.filter(
        (item) => item.value != "paag"
      );
    }
  },

  computed: {
    currentActiveTab() {
      return this.tabs[this.tab];
    },
    paymentMethods() {
      return this.$store.state.operator.payment_methods ?? [];
    },
    withdrawIdPlaceholder() {
      return this.$t("solicitedWithdrawId");
    },
  },

  methods: {
    resetFields() {
      this.depositValue = 0;
    },
    openDialog() {
      if (this.currentActiveTab == this.$t("deposit")) {
        this.depositDialog = true;
      } else if (this.currentActiveTab == this.$t("withdraw")) {
        if (this.withdrawId == this.lastWithdrawId) {
          this.withdrawDialog = true;
          return;
        }

        this.loadingWithdrawData = true;

        const body = {
          withdraw_id: this.withdrawId,
          id_player: this.$store.state.filters.autocompletePlayers.id,
        };

        this.$axios
          .post("/colab/bankOnline/getWithdraw", this.$formdata(body))
          .then((res) => {
            this.withdrawData = res.data.dados;
            this.withdrawDialog = true;
            this.lastWithdrawId = this.withdrawId;
          })
          .catch(() => {})
          .finally(() => {
            this.loadingWithdrawData = false;
          });
      }
    },
    closeDialog() {
      this.dialog = false;
      this.value = "";
    },
  },
};
</script>
